module.exports = __webpack_public_path__ + "static/airush-carve-1f9b33cd0d2f4c1f32dd13f7a3edeea7.jpg";